export const PESTANA_FICHA = {
  INFORMACION_BASICA: 'basica',
  EMISOR: 'emisor',
  DEUDOR: 'deudor',
  FONDEADOR: 'fondeador'
} as const;

export type PestanaFicha = typeof PESTANA_FICHA[keyof typeof PESTANA_FICHA];
